import { Link } from "react-router-dom";
import { HardHat } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="app-footer"
      className="mt-16 border-t border-slate-200 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-md bg-[#0F2137] flex items-center justify-center">
            <HardHat className="w-4 h-4 text-[#F59E0B]" />
          </div>
          <div className="leading-tight">
            <div className="font-display font-bold text-[#0F2137] text-sm">ChantiPlanning</div>
            <div className="font-mono-tech text-[10px] uppercase tracking-wider text-slate-500">
              © {new Date().getFullYear()} — Tous droits réservés
            </div>
          </div>
        </div>
        <nav className="flex flex-wrap gap-x-5 gap-y-2 text-xs">
          <Link
            to="/blog"
            data-testid="footer-blog"
            className="text-slate-600 hover:text-[#0F2137] underline-offset-4 hover:underline"
          >
            Blog
          </Link>
          <Link
            to="/legal/mentions"
            data-testid="footer-mentions"
            className="text-slate-600 hover:text-[#0F2137] underline-offset-4 hover:underline"
          >
            Mentions légales
          </Link>
          <Link
            to="/legal/cgv"
            data-testid="footer-cgv"
            className="text-slate-600 hover:text-[#0F2137] underline-offset-4 hover:underline"
          >
            CGV
          </Link>
          <Link
            to="/legal/confidentialite"
            data-testid="footer-confidentialite"
            className="text-slate-600 hover:text-[#0F2137] underline-offset-4 hover:underline"
          >
            Confidentialité
          </Link>
          <Link
            to="/tarifs"
            data-testid="footer-tarifs"
            className="text-slate-600 hover:text-[#0F2137] underline-offset-4 hover:underline"
          >
            Tarifs
          </Link>
        </nav>
      </div>
    </footer>
  );
}
